import React, { useContext, useEffect, useState } from 'react'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
  makeStyles
} from '@material-ui/core'

import clsx from 'clsx'

import Context from '../../context'

import { addMovie, updateMovie } from '../../services/ClubeApi'

import ImageUploadToS3 from '../../services/ImageUpload'

import history from '../../services/history'

function MovieForm(props) {
  const classes = useStyles()

  const { movieToEdit } = props.location.state || {}

  const { setAboutCurrentPage } = useContext(Context)

  const [errors, setErrors] = useState(null)
  const [loading, setLoading] = useState(false)
  const [imageCover, setImageCover] = useState()
  const [formValues, setFormValues] = useState({
    title: '',
    originalTitle: '',
    synopsis: '',
    trailerUrl: '',
    slug: '',
    cover: '',
    director: '',
    duration: '',
    parentalRating: 1,
    publisher: '',
    ingressoDotComId: 0,
    cast: '',
    genres: '',
    id: 0
  })

  const onFormChanged = e => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value
    })
  }

  const onUploadImage = async e => {
    setImageCover(e.target.files[0])
  }

  const hideErrorsModal = () => setErrors(null)

  const checkErrors = () => {
    let errors = []

    if (!formValues.title.trim()) errors.push('Sem título')
    if (!formValues.originalTitle.trim()) errors.push('Sem título original')
    if (!formValues.synopsis.trim()) errors.push('Sem sinopse')
    if (!formValues.trailerUrl.trim()) errors.push('Sem url do trailer')
    if (!formValues.slug.trim()) errors.push('Sem slug')
    if (!formValues.director.trim()) errors.push('Sem diretor')
    if (!formValues.duration.trim()) errors.push('Sem duração')
    if (!formValues.publisher.trim()) errors.push('Sem publicadora')
    if (!formValues.cast.trim()) errors.push('Sem elenco')
    if (!formValues.genres.trim()) errors.push('Sem gênero')
    if (!formValues.cover) errors.push('Sem imagem de capa')
    else if (
      formValues.cover instanceof File &&
      !['image/jpeg', 'image/png', 'image/gif'].includes(formValues.cover.type)
    )
      errors.push('Tipo de imagem de capa inválido')

    return !!errors.length && errors
  }

  const onSave = async () => {
    let errors = checkErrors()
    if (errors) {
      setErrors(errors)
      return
    }

    if (movieToEdit !== undefined) {
      setLoading(true)
      await updateMovie(formValues)
      setLoading(false)

      history.push('/movies')
      return
    }

    setLoading(true)
    const imageS3 = await ImageUploadToS3(imageCover, 'movie/')

    const response = await addMovie({
      ...formValues,
      cover: imageS3
    })
    setLoading(false)

    history.push({ pathname: '/movieSessionForm', state: response })
  }

  useEffect(() => {
    if (movieToEdit !== undefined) {
      setFormValues({
        title: movieToEdit.title,
        originalTitle: movieToEdit.originalTitle,
        synopsis: movieToEdit.synopsis,
        trailerUrl: movieToEdit.trailerUrl,
        slug: movieToEdit.slug,
        cover: movieToEdit.cover,
        director: movieToEdit.director,
        duration: movieToEdit.duration,
        parentalRating: movieToEdit.parentalRating,
        publisher: movieToEdit.publisher,
        ingressoDotComId: movieToEdit.ingressoDotComId,
        cast: movieToEdit.cast,
        genres: movieToEdit.genres,
        id: movieToEdit.id
      })

      setImageCover(movieToEdit.cover)
    }

    if (movieToEdit !== undefined) {
      setAboutCurrentPage({
        title: 'Novo Filme',
        buttons: [{ title: 'Voltar', pathname: '/movies' }],
        tabs: [
          { title: 'Filmes', pathname: '/movieForm' },
          { title: 'Sessões', pathname: '/sessions', state: { message: movieToEdit } }
        ]
      })

      return
    }

    setAboutCurrentPage({
      title: 'Novo Filme',
      buttons: [{ title: 'Voltar', pathname: '/movies' }],
      tabs: [
        { title: 'Filmes', pathname: '/movieForm' },
        { title: 'Sessões', pathname: '/sessions' }
      ]
    })
  }, [])

  return (
    <>
      <div className={classes.outerContainer}>
        {loading ? <LinearProgress /> : null}
        <div className={classes.content}>
          <div className={classes.main}>
            <div className={classes.inputGroup}>
              <span>Título do filme</span>
              <input name="title" value={formValues.title} onChange={e => onFormChanged(e)} />
            </div>

            <div className={classes.inputGroup}>
              <span>Título original</span>
              <input
                name="originalTitle"
                value={formValues.originalTitle}
                onChange={e => onFormChanged(e)}
              />
            </div>
            <div className={classes.inputGroup}>
              <span>Sinopse</span>
              <textarea
                name="synopsis"
                value={formValues.synopsis}
                onChange={e => onFormChanged(e)}
              />
            </div>

            <div className={classes.inputGroup}>
              <span>Elenco</span>
              <input name="cast" value={formValues.cast} onChange={e => onFormChanged(e)} />
            </div>

            <div className={classes.inputGroup}>
              <span>URL trailer</span>
              <input
                name="trailerUrl"
                value={formValues.trailerUrl}
                onChange={e => onFormChanged(e)}
              />
            </div>

            <div className={classes.inputGroup}>
              <span>Slug</span>
              <input name="slug" value={formValues.slug} onChange={e => onFormChanged(e)} />
            </div>

            <div className={classes.inputGroup}>
              <span>Diretor</span>
              <input name="director" value={formValues.director} onChange={e => onFormChanged(e)} />
            </div>

            <div className={classes.inputGroup}>
              <span>Duração (min)</span>
              <input name="duration" value={formValues.duration} onChange={e => onFormChanged(e)} />
            </div>

            <div className={classes.inputGroup}>
              <span>Publicadora</span>
              <input
                name="publisher"
                value={formValues.publisher}
                onChange={e => onFormChanged(e)}
              />
            </div>

            <div className={classes.inputGroup}>
              <span>Gêneros</span>
              <input name="genres" value={formValues.genres} onChange={e => onFormChanged(e)} />
            </div>
          </div>

          <div className={classes.aside}>
            <div className={clsx(classes.box, classes.fullRowTwoColumns)}>
              <h4>Imagem de capa</h4>
              <div>
                <label>
                  {imageCover ? (
                    <img
                      className={classes.img}
                      src={(image =>
                        image instanceof File
                          ? URL.createObjectURL(image)
                          : process.env.REACT_APP_IMAGES_URL + image)(imageCover)}
                    />
                  ) : null}
                  <span className={classes.plainButton}>Selecionar arquivo</span>
                  <input
                    className={classes.hiddenInput}
                    type="file"
                    accept="image/png,image/jpeg,image/gif"
                    onChange={e => onUploadImage(e)}
                  />
                </label>
                <span className={classes.legend}>Arquivo .png, .jpg ou .gif</span>
              </div>
            </div>
            <button
              className={clsx(classes.shadowButton, classes.fullRowTwoColumns)}
              type="button"
              onClick={onSave}
            >
              Publicar
            </button>
          </div>
        </div>
      </div>

      <Dialog
        open={!!errors}
        onClose={hideErrorsModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Erros encontrados</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Encontramos os seguintes erros:
            <ul>
              {errors?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            Corrija-os antes de prosseguir.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={hideErrorsModal}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

const useStyles = makeStyles({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat',
    fontWeight: '500',
    '& label': {
      margin: '0 !important'
    }
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '45px'
  },
  main: {
    flexGrow: 1,
    display: 'grid',
    flexDirection: 'auto',
    marginRight: 30,
    gap: '30px'
  },
  group: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr) min-content',
    alignItems: 'end',
    padding: '30px',
    gap: '20px 30px',
    backgroundColor: '#ece5fe',
    borderRadius: '4px'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    '& > span': {
      fontSize: '16px',
      fontWeight: 700,
      color: '#30287b'
    },
    '& > input, & > div, & textarea': {
      marginTop: '10px',
      background: '#fff',
      border: '2px solid #30287b !important'
    },
    '& input, & textarea': {
      padding: '11px 13px',
      fontSize: '14px',
      color: '#30287b',
      border: 'none'
    },
    '& > div': {
      display: 'flex',
      flexDirection: 'row'
    },
    '& > div input': {
      flexGrow: 1,
      height: '100%'
    },
    '& > input, & > div': {
      height: 44
    },
    '& textarea': {
      minHeight: 132,
      resize: 'none'
    }
  },
  dateInputGroup: {
    width: 'fit-content',
    '& *::before': {
      display: 'none !important'
    },
    '& *::after': {
      display: 'none !important'
    }
  },
  divider: {
    marginTop: '15px',
    borderBottom: '2px solid #b294ff'
  },
  divider2: {
    margin: '10px -30px',
    borderBottom: '2px solid #b294ff'
  },
  subtitle: {
    margin: '15px 0 0',
    fontFamily: 'Matrice',
    fontSize: '18px',
    color: '#30287b'
  },
  subtitle2: {
    height: '25px',
    margin: '10px 0 0',
    fontFamily: 'Matrice',
    fontSize: '16px',
    color: '#30287b',
    lineHeight: '25px'
  },
  aside: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, auto)',
    width: 340,
    gap: '15px'
  },
  fullRowTwoColumns: {
    gridColumn: '1 / 3'
  },
  fullRowThreeColumns: {
    gridColumn: '1 / 4'
  },
  box: {
    border: '2px solid #30287b',
    '& h4': {
      marginBottom: 0,
      fontSize: '14px',
      fontWeight: '700',
      color: '#ffffff',
      lineHeight: '44px',
      textAlign: 'center',
      textTransform: 'uppercase',
      background: '#30287b',
      borderBottom: '2px solid #30287b'
    },
    '& > div': {
      display: 'grid',
      gridTemplateColumns: 'auto',
      gap: '15px',
      padding: '30px'
    },
    '& table': {
      width: '100%',
      '& td': {
        padding: '15px',
        color: '#30287b'
      },
      '& tbody td:first-child': {
        fontSize: '18px',
        fontWeight: 700,
        textAlign: 'center'
      },
      '& tbody td:nth-child(2)': {
        overflow: 'hidden',
        width: '100%',
        fontSize: '14px',
        fontWeight: 700,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
      },
      '& tbody td:last-child': {
        fontSize: '14px',
        fontWeight: 500,
        whiteSpace: 'nowrap'
      },
      '& tfoot': {
        fontSize: '12px',
        fontWeight: 700,
        textAlign: 'center',
        textTransform: 'uppercase',
        borderTop: '2px solid #30387b',
        cursor: 'pointer'
      }
    }
  },
  plainButton: {
    display: 'block',
    width: '100%',
    margin: '0',
    padding: '0 20px',
    fontSize: '12px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '44px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#ece5fe',
    border: 'none',
    borderRadius: '2px',
    cursor: 'pointer'
  },
  plainButton2: {
    display: 'block',
    margin: '2px',
    padding: '6px 5px',
    fontSize: '11px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '24px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#ece5fe',
    border: 'none',
    borderRadius: '2px',
    cursor: 'pointer'
  },
  plainButtonRed: {
    color: '#fff',
    background: '#d73f32'
  },
  plainButtonGreen: {
    color: '#fff',
    background: '#13735e'
  },
  shadowButton: {
    width: '100%',
    fontSize: '12px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '44px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#fbbb33',
    border: 'none',
    borderRadius: '2px',
    boxShadow: '4px 4px #4200f5',
    cursor: 'pointer'
  },
  img: {
    width: '100%',
    height: 'auto'
  },
  hiddenInput: {
    visibility: 'hidden',
    opacity: 0,
    position: 'absolute',
    width: 0,
    height: 0,
    margin: 0,
    padding: 0
  },
  legend: {
    fontSize: '12px',
    fontStyle: 'italic',
    color: '#30287b',
    textAlign: 'center'
  },
  ul: {
    listStyle: 'none',
    margin: '15px 0',
    padding: '0',
    '& li': {
      margin: '6px 0 0',
      fontSize: '14px',
      fontStyle: 'italic',
      color: '#30287b'
    }
  },
  correctTag: {
    display: 'inline-block',
    marginLeft: '16px',
    padding: '5px 12px',
    fontFamily: 'Montserrat',
    fontSize: '12px',
    fontWeight: 600,
    color: '#fff',
    lineHeight: '15px',
    backgroundColor: '#13735e',
    borderRadius: 2
  },
  excludeAnswer: {
    display: 'inline-block',
    marginLeft: '16px',
    padding: '5px 12px',
    fontFamily: 'Montserrat',
    fontSize: '12px',
    fontWeight: 600,
    color: '#fff',
    lineHeight: '15px',
    backgroundColor: '#d73f32',
    borderRadius: 2,
    cursor: 'pointer'
  },
  noPadding: {
    padding: '0 !important'
  },
  checkbox: {
    paddingLeft: 0,
    paddingRight: 0,
    color: '#30287b'
  },
  end: {
    justifySelf: 'end',
    width: 'fit-content'
  },
  addButton: {
    justifySelf: 'center',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '11px 15px',
    fontSize: '12px',
    fontWeight: 700,
    color: '#30287b',
    lineHeight: '15px',
    textTransform: 'uppercase',
    border: '2px solid #30287b',
    borderRadius: 4,
    cursor: 'pointer',
    '& svg': {
      marginRight: '6px',
      fontSize: '18px'
    }
  },
  pointer: {
    cursor: 'pointer'
  }
})

export default MovieForm
